export default "__VITE_ASSET__CCCbfeyM__"